import * as Popper from "@popperjs/core";
import * as bootstrap from "bootstrap";
import Flickity from "flickity";

window.Popper = Popper;
window.bootstrap = bootstrap;
window.Flickity = Flickity;
